import React from "react";

//  Styles \\
import "../../assets/styles/sections/news.scss";

// Swipper \\
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import NewsCard from "../cards/NewsCard";

const News = () => {
  return (
    <div>
      <section className="news">
        <div className="container">
          <div className="news_items">
            <div className="news_items_title">
              <h3>Better information, Better health</h3>
              <p>News</p>
            </div>

            <div className="card_box">
              <Swiper
                className="swipperHead"
                modules={[Navigation, Pagination, Scrollbar, A11y]}
                spaceBetween={170}
                slidesPerView={1}
                onSetTransition={true}
                pagination={{ clickable: true }}
                onSlideChange={() => console.log("slide change")}
              >
                <SwiperSlide className="cards">
                  <div className="top">
                    <NewsCard />
                    <NewsCard />
                  </div>
                  <div className="top">
                    <NewsCard />
                    <NewsCard />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="cards">
                  <div className="top">
                    <NewsCard />
                    <NewsCard />
                  </div>
                  <div className="top">
                    <NewsCard />
                    <NewsCard />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="cards">
                  <div className="top">
                    <NewsCard />
                    <NewsCard />
                  </div>
                  <div className="top">
                    <NewsCard />
                    <NewsCard />
                  </div>
                </SwiperSlide>

                <div className="dot">...</div>
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;
